import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

/** Bouton de bascule clair/sombre, réutilisable dans le header public, l'espace client et l'admin. */
export const ThemeToggle = ({ className = '', compact = false }) => {
  const { theme, toggleTheme } = useTheme();
  const isLight = theme === 'light';

  if (compact) {
    return (
      <button
        onClick={toggleTheme}
        className={`inline-flex items-center justify-center w-8 h-8 rounded-full text-zinc-300 hover:text-white hover:bg-white/10 transition-colors ${className}`}
        title={isLight ? 'Passer en mode sombre' : 'Passer en mode clair'}
        aria-label={isLight ? 'Passer en mode sombre' : 'Passer en mode clair'}
        data-testid="theme-toggle-btn"
      >
        {isLight ? <Moon className="w-4 h-4" /> : <Sun className="w-4 h-4" />}
      </button>
    );
  }

  return (
    <button
      onClick={toggleTheme}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-bold text-zinc-300 hover:text-white hover:bg-white/5 transition-colors ${className}`}
      title={isLight ? 'Passer en mode sombre' : 'Passer en mode clair'}
      aria-label={isLight ? 'Passer en mode sombre' : 'Passer en mode clair'}
      data-testid="theme-toggle-btn"
    >
      {isLight ? <Moon className="w-3.5 h-3.5" /> : <Sun className="w-3.5 h-3.5" />}
      <span className="hidden sm:inline">{isLight ? 'Sombre' : 'Clair'}</span>
    </button>
  );
};

export default ThemeToggle;
